"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Component = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reactDnd = require("react-dnd");

var _forEach2 = _interopRequireDefault(require("lodash/forEach"));

var _without2 = _interopRequireDefault(require("lodash/without"));

var _union2 = _interopRequireDefault(require("lodash/union"));

var _filter2 = _interopRequireDefault(require("lodash/filter"));

var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));

var _throttle2 = _interopRequireDefault(require("lodash/throttle"));

var _element = _interopRequireDefault(require("./element.js"));

var _builder = require("./selectors/builder.js");

var _config = require("./config.js");

var _FirstElement = _interopRequireDefault(require("./FirstElement.js"));

var _LastElement = _interopRequireDefault(require("./LastElement.js"));

var _store = _interopRequireDefault(require("store"));

var _md = _interopRequireDefault(require("md5"));

var _style = _interopRequireDefault(require("./style.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var target = {
  hover: (0, _throttle2.default)(function (props, monitor, component) {
    // update dragged element
    var item = monitor.getItem();
    var draggedElement = {
      id: item.element.id || 0,
      type: item.element.id ? item.element.type : item.element.code,
      isParentAllowed: item.element.isParentAllowed
    };

    if (!(0, _isEqual2.default)(draggedElement, component.state.draggedElement)) {
      component._setDraggedElement(draggedElement);
    }

    var TREE_INDENTATION = component.props.indentSize; // Determine rectangle on screen

    var hoverBoundingRect = _reactDom.default.findDOMNode(component).getBoundingClientRect(); // Determine mouse position


    var clientOffset = monitor.getClientOffset();

    var hoverClientX = clientOffset.x - hoverBoundingRect.left - component._getCollapsedIndent();

    var leftHover = clientOffset.x - hoverBoundingRect.left;
    var level = Math.max(Math.floor(hoverClientX / TREE_INDENTATION) + 1, 1); // Check if we need to show placeholder

    var showPlaceholder = leftHover > _config.PLACEHOLDER_DOT_INDENTATION;

    if (showPlaceholder !== component.state.showPlaceholder) {
      component.setState({
        showPlaceholder: showPlaceholder
      });
    } // Check if we can drop an element


    var canDrop = component._getCanDrop();

    if (canDrop !== component.state.canDrop) {
      component._setCanDrop(canDrop);
    } // Check if we hovered element is changed


    var prevLevel = component.state.hoveredElement.level;

    if (prevLevel !== level) {
      component._hoverElement({
        level: level
      });
    }
  }, 1000 / 30, {
    trailing: false
  }),
  drop: function drop(props, monitor, component) {
    var canDrop = component._getCanDrop();

    if (canDrop) {
      var item = monitor.getItem();

      var _component$_getPlaceh = component._getPlaceholderPosition(),
          placeholderBefore = _component$_getPlaceh.placeholderBefore,
          placeholderParentId = _component$_getPlaceh.placeholderParentId;

      props.onDrop(item.element, placeholderParentId, placeholderBefore);
    }

    component._resetDraggedElement();
  }
};

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  };
}

var Component = /*#__PURE__*/function (_React$Component) {
  _inherits(Component, _React$Component);

  var _super = _createSuper(Component);

  function Component(props) {
    var _this;

    _classCallCheck(this, Component);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_getCollapsedIndent", function () {
      var tree = _this.props.tree;

      if (!tree.children || tree.children.length === 0) {
        return 0;
      }

      if ((0, _filter2.default)(tree.children, {
        isAdult: true
      }).length > 0) {
        return _config.COLLAPSED_ICON_INDENTATION;
      }

      return 0;
    });

    _defineProperty(_assertThisInitialized(_this), "_getReselectState", function () {
      return _objectSpread({
        tree: _this.props.tree
      }, _this.state);
    });

    _defineProperty(_assertThisInitialized(_this), "_getCode", function () {
      return (0, _md.default)((_this.props.dragDropCode || _this.props.dragDropType) + window.location.pathname);
    });

    _defineProperty(_assertThisInitialized(_this), "_getSavedState", function () {
      var savedState = _store.default.get(_config.STORAGE_KEY) || {};
      return savedState[_this._getCode()] || {};
    });

    _defineProperty(_assertThisInitialized(_this), "_saveState", function () {
      var savedState = _store.default.get(_config.STORAGE_KEY) || {};

      _store.default.set(_config.STORAGE_KEY, _objectSpread({}, savedState, _defineProperty({}, _this._getCode(), {
        collapsedElements: _this.state.collapsedElements
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "_toggleCollapsedElementState", function (elementId) {
      var collapsedElements = _this.state.collapsedElements.includes(elementId) ? (0, _without2.default)(_this.state.collapsedElements, elementId) : (0, _union2.default)(_this.state.collapsedElements, [elementId]);

      _this.setState({
        collapsedElements: collapsedElements
      }, _this._saveState);
    });

    _defineProperty(_assertThisInitialized(_this), "_hoverElement", function (element) {
      if (element.id !== 0 && element.id === _this.state.draggedElement.id) {
        return;
      }

      _this.setState({
        hoveredElement: _objectSpread({}, _this.state.hoveredElement, {}, element)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_resetHoveredElement", function () {
      _this.setState({
        hoveredElement: {
          id: 0,
          top: false,
          middle: false,
          bottom: false,
          level: 1
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_setDraggedElement", function (draggedElement) {
      _this.setState({
        draggedElement: draggedElement
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_resetDraggedElement", function () {
      if (_this._mounted) {
        _this.setState({
          draggedElement: {
            id: 0,
            type: ''
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_getPlaceholderPosition", function () {
      return (0, _builder.getPlaceholderPosition)(_this._getReselectState());
    });

    _defineProperty(_assertThisInitialized(_this), "_setCanDrop", function (canDrop) {
      _this.setState({
        canDrop: canDrop
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_getCanDrop", function () {
      return (0, _builder.getCanDrop)(_this._getReselectState());
    });

    _defineProperty(_assertThisInitialized(_this), "_getPlaceholder", function () {
      var level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return /*#__PURE__*/_react.default.createElement("div", {
        key: "placeholder",
        className: _style.default.placeholder + ' ' + (_this.state.canDrop ? '' : _style.default.disabledDrop),
        style: {
          marginLeft: "".concat((level - 1) * _this.props.indentSize + _this._getCollapsedIndent(), "px")
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_getElements", function (list) {
      var _this$_getPlaceholder = _this._getPlaceholderPosition(),
          placeholderBefore = _this$_getPlaceholder.placeholderBefore,
          placeholderParentId = _this$_getPlaceholder.placeholderParentId;

      var result = [];
      (0, _forEach2.default)(list.children, function (element) {
        if (_this.props.isOver && _this.state.showPlaceholder && element.id === placeholderBefore && element.parents[0] === placeholderParentId) {
          result.push(_this._getPlaceholder(element.level));
        }

        var isCollapsed = _this.state.collapsedElements.includes(element.id);

        result.push( /*#__PURE__*/_react.default.createElement(_element.default, {
          key: element.id,
          element: element,
          dragDropType: _this.props.dragDropType,
          indentSize: _this.props.indentSize,
          isCollapsed: isCollapsed,
          hoveredElement: _this.state.hoveredElement,
          hoverElement: _this._hoverElement,
          toggleCollapsedElementState: _this._toggleCollapsedElementState,
          collapsedIndent: _this._getCollapsedIndent(),
          isPlaceholderParent: placeholderParentId === element.id
        }));

        if (element.isAdult && !isCollapsed) {
          result.push( /*#__PURE__*/_react.default.createElement("div", {
            key: element.id + 'children'
          }, _this._getElements(element)));
        }
      });

      if (_this.props.isOver && _this.state.showPlaceholder && placeholderBefore === 0 && placeholderParentId === list.id) {
        result.push(_this._getPlaceholder(list.level + 1));
      }

      return result;
    });

    _this.state = _objectSpread({
      draggedElement: {
        id: 0,
        type: ''
      },
      canDrop: false,
      hoveredElement: {
        id: 0,
        top: false,
        middle: false,
        bottom: false,
        level: 1
      },
      collapsedElements: [],
      showPlaceholder: false
    }, _this._getSavedState());
    return _this;
  }

  _createClass(Component, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._mounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._mounted = false;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      if (!this.props.isOver && prevProps.isOver) {
        // Hack! SetTimout allows onDrop handles the correct hoveredElement before resetting
        setTimeout(function () {
          _this2._resetHoveredElement();
        }, 200);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          connectDropTarget = _this$props.connectDropTarget,
          wrapperStyle = _this$props.wrapperStyle,
          showBottomMargin = _this$props.showBottomMargin;

      var elements = this._getElements((0, _builder.getAdjustedTree)(this._getReselectState()));

      var firstElementId = (0, _builder.getFirstElementId)(this._getReselectState());
      var lastElementId = (0, _builder.getLastElementId)(this._getReselectState());
      return connectDropTarget( /*#__PURE__*/_react.default.createElement("div", {
        className: _style.default.listWrapper,
        style: wrapperStyle
      }, elements.length > 0 ? /*#__PURE__*/_react.default.createElement("div", {
        style: {
          paddingBottom: '3px'
        }
      }, /*#__PURE__*/_react.default.createElement(_FirstElement.default, {
        dragDropType: this.props.dragDropType,
        firstElementId: firstElementId,
        hoverElement: this._hoverElement,
        hoveredElement: this.state.hoveredElement
      }), elements, showBottomMargin && /*#__PURE__*/_react.default.createElement(_LastElement.default, {
        dragDropType: this.props.dragDropType,
        hoverElement: this._hoverElement,
        lastElementId: lastElementId,
        hoveredElement: this.state.hoveredElement
      })) : /*#__PURE__*/_react.default.createElement("div", {
        className: _style.default.dragDropHint
      }, this.props.dragDropHint)));
    }
  }]);

  return Component;
}(_react.default.Component);

exports.Component = Component;

_defineProperty(Component, "propTypes", {
  connectDropTarget: _propTypes.default.func.isRequired,
  isOver: _propTypes.default.bool.isRequired,
  tree: _propTypes.default.object.isRequired,
  dragDropType: _propTypes.default.string.isRequired,
  dragDropCode: _propTypes.default.string,
  onDrop: _propTypes.default.func.isRequired,
  indentSize: _propTypes.default.number,
  dragDropHint: _propTypes.default.string,
  wrapperStyle: _propTypes.default.object,
  showBottomMargin: _propTypes.default.bool
});

_defineProperty(Component, "defaultProps", {
  // Indent size for the next level
  indentSize: 40,
  dragDropCode: null,
  dragDropHint: 'Drag elements here',
  wrapperStyle: {},
  showBottomMargin: true
});

var _default = (0, _reactDnd.DropTarget)(function (props) {
  return props.dragDropType;
}, target, collect)(Component);

exports.default = _default;